module.exports = {
	"en": {
		"app.welcome": "Welcome, {name}",
		"app.quote": "“Surf the web, save the world.”"
	},
	"es": {
		"app.welcome": "Bienvenido, {name}",
		"app.quote": "“Navega la web, salva el mundo.”"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/js/assets/locales/data.json
// module id = 1824
// module chunks = 0